import { H2 } from "@/components/ui/typography";
import { Bell, BellOff, BellRing, CheckCircle2, Clock } from "lucide-react";
import NotificationTable from "./NotificationTable";
import {
  useNotifications,
  useNotificationSummary,
  useReadAllNotification,
  useUnreadAllNotifications,
} from "@/api/notifications";
import { useDefaultDataConfig } from "@/components/table/useDefaultDataConfig";

export default function NotificationList() {
  const { mutate: readAll } = useReadAllNotification();
  const { mutate: unreadAll } = useUnreadAllNotifications();
  const { dataConfig, setDataConfig } = useDefaultDataConfig();
  const { data: notifications, isLoading } = useNotifications(dataConfig);
  const { data: summaries } = useNotificationSummary();

  return (
    <>
      {/* Page header */}
      <div className=" flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50">
            <Bell size={20} className="text-axiata-blue" />
          </div>
          <H2>Notifications</H2>
        </div>
        <div className="flex items-center gap-2">
          <button
            className="flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3.5 py-2 text-sm text-gray-600 transition-all hover:border-gray-300 hover:bg-gray-50"
            onClick={() => {
              unreadAll();
            }}
          >
            <BellOff size={14} />
            Mark All as Unread
          </button>
          <button
            className="flex items-center gap-2 rounded-lg bg-axiata-blue px-3.5 py-2 text-sm text-white transition-all hover:bg-blue-700"
            onClick={() => {
              readAll();
            }}
          >
            <BellRing size={14} />
            Mark All as Read
          </button>
        </div>
      </div>

      <div className=" grid grid-cols-3 gap-4">
        <div className="rounded-xl border border-gray-100 bg-white p-4 shadow">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-amber-50">
              <Clock size={18} className="text-amber-500" />
            </div>
            <div>
              <p className="text-2xl font-semibold leading-none text-gray-900">
                {summaries?.unreadTodo}
              </p>
              <p className="mt-1 text-xs text-gray-400">Unread — Todo</p>
            </div>
          </div>
        </div>
        <div className="rounded-xl border border-gray-100 bg-white p-4 shadow">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-50">
              <Bell size={18} className="text-blue-500" />
            </div>
            <div>
              <p className="text-2xl font-semibold leading-none text-gray-900">
                {summaries?.unreadNotification}
              </p>
              <p className="mt-1 text-xs text-gray-400">
                Unread — Notification
              </p>
            </div>
          </div>
        </div>
        <div className="rounded-xl border border-gray-100 bg-white p-4 shadow">
          <div className="flex items-center gap-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-emerald-50">
              <CheckCircle2 size={18} className="text-emerald-500" />
            </div>
            <div>
              <p className="text-2xl font-semibold leading-none text-gray-900">
                {summaries?.readCount}
              </p>
              <p className="mt-1 text-xs text-gray-400">Read</p>
            </div>
          </div>
        </div>
      </div>

      <NotificationTable
        notifications={notifications}
        isLoading={isLoading}
        dataConfig={dataConfig}
        setDataConfig={setDataConfig}
      />
    </>
  );
}
